 import FrontPreview from '../views/front/Preview.vue'
 import Preview from '../views/Preview.vue'
 const routes = [
	{
		path: '/categories/:id',
		name: 'FrontCategories',
		meta:{
			title:"h.categoriesPage",
			id:""
		},
		component: FrontPreview
	},
	
	// {
	// 	path: '/typeProducts/:id',
	// 	name: 'FrontTypeProducts',
	// 	meta:{
	// 		title:"h.typeGoods",
	// 		id:""
	// 	},
	// 	component: FrontPreview
	// },
	
	{
		path: '/categories_products/:id',
		name: 'FrontTypeProducts',
		meta:{
			title:"h.goods",
			id:""
		},
		component: FrontPreview
	},
	
	
	
	{
		path: '/page_categories',
		name: 'FrontPageCategories',
		component: FrontPreview
	},
	{
		path: '/page_categories/:id',
		name: 'FrontPageCategories',
		component: FrontPreview,
		meta:{
			title:"h.page_categoriesPage",
			id:""
		},
	},
	{
		path: '/userlogin',
		name: 'FrontUserLogin',
		component: FrontPreview,
		meta:{
			title:"h.userloginPage",
			id:""
		},
	},
	{
		path: '/products/:id',
		name: 'FrontProducts',
		component: FrontPreview,
		meta:{
			title:"h.productsPage",
			id:""
		},
	},
	{
		path: '/blank',
		name: 'FrontBank',
		component: FrontPreview
	},
	{
		path: '/products_search/search',
		name: 'FrontSearch',
		meta:{
			title:"h.search",
			id:""
		},
		component: FrontPreview
	},
	{
		path: '/search_center',
		name: 'FrontSearchCenter',
		meta:{
			title:"h.search",
			id:""
		},
		component: FrontPreview
	},
	{
		path: '/brands/:id',
		name: 'FrontBrandsId',
		component: FrontPreview,
		meta:{
			title:"h.brandsPageList",
			id:""
		},
	},
	{
		path: '/brandsPage',
		name: 'FrontBrandsPage',
		meta:{
			title:"h.brandsPage",
			id:""
		},
		component: FrontPreview
	},
	{
		path: '/account/wishlist',
		name: 'FrontWishlist',
		component: FrontPreview,
		meta:{
			title:"h.wishlistPage",
			id:""
		},
		
	},
	{
		path: '/account',
		name: 'FrontAccount',
		component: FrontPreview,
		meta:{
			title:"h.accountPage",
			id:""
		},
	},
	{
		path: '/carts',
		name: 'FrontCarts',
		component: FrontPreview,
		meta:{
			title:"h.cartsPage",
			id:""
		},
	},
	{
		path: '/latest_products',
		name: 'FrontLatest_products',
		component: FrontPreview
	},
	{
		path: '/page_categories/:id',
		name: 'FrontPage_categories',
		component: FrontPreview
	},
	{
		path: '/checkout',
		name: 'FrontPage_checkout',
		component: FrontPreview,
		meta:{
			title:"h.checkoutPage",
			id:""
		},
	},
	{
		path: '/orders/:id/pay',
		name: 'FrontPage_pay',
		component: FrontPreview,
		
	},
	{
		path: '/account/orders/:id',
		name: 'FrontPage_account_orders',
		component: FrontPreview,
		meta:{
			title:"h.accountPage",
			id:""
		},
		
	},
	{
		path: '/pages/:id',
		name: 'FrontPage_pages',
		component: FrontPreview,
		meta:{
			title:"h.pagesPage",
			id:""
		},
	},
	{
		path: '/pages',
		name: 'FrontPage_pages',
		component: FrontPreview
	},
	{
		path: '/account/orders',
		name: 'FrontPage_account_orders',
		component: FrontPreview,
		meta:{
			title:"h.accountPage",
			id:""
		},
	},
	{
		path: '/account/password',
		name: 'FrontPage_account_password',
		component: FrontPreview,
		meta:{
			title:"h.passwordPage",
			id:""
		},
	},
	{
		path: '/account/edit',
		name: 'FrontPage_edit',
		component: FrontPreview,
		meta:{
			title:"h.editPage",
			id:""
		},
	},
	{
		path: '/account/addresses',
		name: 'FrontPage_addresses',
		component: FrontPreview,
		meta:{
			title:"h.addressesPage",
			id:""
		},
	},
	{
		path: '/account/rmas',
		name: 'FrontPage_rmas',
		component: FrontPreview,
		meta:{
			title:"h.rmasPage",
			id:""
		},
	},
	
	{
		path: '/commission/shop/orders_index',
		name: 'commissionOrders',
		component: FrontPreview,
		meta:{
			title:"h.commissionPage",
			id:""
		},
	},
	{
		path: '/commission/shop/users_index',
		name: 'commissionUsers',
		meta:{
			title:"h.commissionPage",
			id:""
		},
		component: FrontPreview
	},
	{
		path: '/preview',
		name: 'preview',
		component: Preview
	},
	{
		path: '/success_order_checkout/:id',
		name: 'checkoutSuccess',
		meta:{
			title:"h.success_order_checkoutPage",
			id:""
		},
		component: FrontPreview
	},
]
export default routes